import React from 'react';
import PropTypes from 'prop-types';
import styles from './andOn.css';
import { Row, Col, Container } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faChartPie, faTemperatureHigh, faClock } from '@fortawesome/free-solid-svg-icons';

const CncAndOn = () => (
  <div className={styles.andOn} data-testid="andOn">
    <Container fluid>
      <Row>
        <Col xs='12' sm='6' md='4'>
          <div className="i4AndOn bg-dark">
            <div className="i4AndOnHead">
              <h3>ISEC_21</h3>
              <p>Part_XX</p>
              <p><small>User_XX</small></p>
            </div>
            <div className="i4AndOnBody">
              <ul>
                <li className="bg-danger"><FontAwesomeIcon icon={faClock}/><br/>Downtime<br/>11:00</li>
                <li className="bg-success"><FontAwesomeIcon icon={faBan}/><br/>Reject Qty<br/>11</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faChartPie}/><br/>OEE<br/>99%</li>
                <li className="bg-success"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Oil Temp<br/>25°</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Metal Temp<br/>11°</li>
                <li className="bg-danger"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Die Temp<br/>99°</li>
              </ul>
            </div>
            <div className="i4AndOnFooter">
              <ul>
                <li>Lub Oil<br/>Level<br/><span className="led-green"></span></li>
                <li>Hyd. Oil<br/>Level<br/><span className="led-red"></span></li>
                <li>Lub<br/>Pressure<br/><span className="led-green"></span></li>
                <li>Safety<br/>Curtain<br/><span className="led-red"></span></li>
              </ul>
            </div>
          </div>
        </Col>
        <Col xs='12' sm='6' md='4'>
          <div className="i4AndOn bg-dark">
            <div className="i4AndOnHead">
              <h3>ISEC_22</h3>
              <p>Part_XX</p>
              <p><small>User_XX</small></p>
            </div>
            <div className="i4AndOnBody">
              <ul>
                <li className="bg-danger"><FontAwesomeIcon icon={faClock}/><br/>Downtime<br/>11:00</li>
                <li className="bg-success"><FontAwesomeIcon icon={faBan}/><br/>Reject Qty<br/>11</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faChartPie}/><br/>OEE<br/>99%</li>
                <li className="bg-success"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Oil Temp<br/>25°</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Metal Temp<br/>11°</li>
                <li className="bg-danger"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Die Temp<br/>99°</li>
              </ul>
            </div>
            <div className="i4AndOnFooter">
              <ul>
                <li>Lub Oil<br/>Level<br/><span className="led-green"></span></li>
                <li>Hyd. Oil<br/>Level<br/><span className="led-red"></span></li>
                <li>Lub<br/>Pressure<br/><span className="led-green"></span></li>
                <li>Safety<br/>Curtain<br/><span className="led-red"></span></li>
              </ul>
            </div>
          </div>
        </Col>
        <Col xs='12' sm='6' md='4'>
          <div className="i4AndOn bg-dark">
            <div className="i4AndOnHead">
              <h3>ISEC_23</h3>
              <p>Part_XX</p>
              <p><small>User_XX</small></p>
            </div>
            <div className="i4AndOnBody">
              <ul>
                <li className="bg-danger"><FontAwesomeIcon icon={faClock}/><br/>Downtime<br/>11:00</li>
                <li className="bg-success"><FontAwesomeIcon icon={faBan}/><br/>Reject Qty<br/>11</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faChartPie}/><br/>OEE<br/>99%</li>
                <li className="bg-success"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Oil Temp<br/>25°</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Metal Temp<br/>11°</li>
                <li className="bg-danger"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Die Temp<br/>99°</li>
              </ul>
            </div>
            <div className="i4AndOnFooter">
              <ul>
                <li>Lub Oil<br/>Level<br/><span className="led-green"></span></li>
                <li>Hyd. Oil<br/>Level<br/><span className="led-red"></span></li>
                <li>Lub<br/>Pressure<br/><span className="led-green"></span></li>
                <li>Safety<br/>Curtain<br/><span className="led-red"></span></li>
              </ul>
            </div>
          </div>
        </Col>
        <Col xs='12' sm='6' md='4'>
          <div className="i4AndOn bg-dark">
            <div className="i4AndOnHead">
              <h3>ISEC_24</h3>
              <p>Part_XX</p>
              <p><small>User_XX</small></p>
            </div>
            <div className="i4AndOnBody">
              <ul>
                <li className="bg-danger"><FontAwesomeIcon icon={faClock}/><br/>Downtime<br/>11:00</li>
                <li className="bg-success"><FontAwesomeIcon icon={faBan}/><br/>Reject Qty<br/>11</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faChartPie}/><br/>OEE<br/>99%</li>
                <li className="bg-success"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Oil Temp<br/>25°</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Metal Temp<br/>11°</li>
                <li className="bg-danger"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Die Temp<br/>99°</li>
              </ul>
            </div>
            <div className="i4AndOnFooter">
              <ul>
                <li>Lub Oil<br/>Level<br/><span className="led-green"></span></li>
                <li>Hyd. Oil<br/>Level<br/><span className="led-red"></span></li>
                <li>Lub<br/>Pressure<br/><span className="led-green"></span></li>
                <li>Safety<br/>Curtain<br/><span className="led-red"></span></li>
              </ul>
            </div>
          </div>
        </Col>
        <Col xs='12' sm='6' md='4'>
          <div className="i4AndOn bg-dark">
            <div className="i4AndOnHead">
              <h3>ISEC_26</h3>
              <p>Part_XX</p>
              <p><small>User_XX</small></p>
            </div>
            <div className="i4AndOnBody">
              <ul>
                <li className="bg-danger"><FontAwesomeIcon icon={faClock}/><br/>Downtime<br/>11:00</li>
                <li className="bg-success"><FontAwesomeIcon icon={faBan}/><br/>Reject Qty<br/>11</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faChartPie}/><br/>OEE<br/>99%</li>
                <li className="bg-success"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Oil Temp<br/>25°</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Metal Temp<br/>11°</li>
                <li className="bg-danger"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Die Temp<br/>99°</li>
              </ul>
            </div>
            <div className="i4AndOnFooter">
              <ul>
                <li>Lub Oil<br/>Level<br/><span className="led-green"></span></li>
                <li>Hyd. Oil<br/>Level<br/><span className="led-red"></span></li>
                <li>Lub<br/>Pressure<br/><span className="led-green"></span></li>
                <li>Safety<br/>Curtain<br/><span className="led-red"></span></li>
              </ul>
            </div>
          </div>
        </Col>
        <Col xs='12' sm='6' md='4'>
          <div className="i4AndOn bg-dark">
            <div className="i4AndOnHead">
              <h3>ISEC_26</h3>
              <p>Part_XX</p>
              <p><small>User_XX</small></p>
            </div>
            <div className="i4AndOnBody">
              <ul>
                <li className="bg-danger"><FontAwesomeIcon icon={faClock}/><br/>Downtime<br/>11:00</li>
                <li className="bg-success"><FontAwesomeIcon icon={faBan}/><br/>Reject Qty<br/>11</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faChartPie}/><br/>OEE<br/>99%</li>
                <li className="bg-success"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Oil Temp<br/>25°</li>
                <li className="bg-warning"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Metal Temp<br/>11°</li>
                <li className="bg-danger"><FontAwesomeIcon icon={faTemperatureHigh}/><br/>Die Temp<br/>99°</li>
              </ul>
            </div>
            <div className="i4AndOnFooter">
              <ul>
                <li>Lub Oil<br/>Level<br/><span className="led-green"></span></li>
                <li>Hyd. Oil<br/>Level<br/><span className="led-red"></span></li>
                <li>Lub<br/>Pressure<br/><span className="led-green"></span></li>
                <li>Safety<br/>Curtain<br/><span className="led-red"></span></li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

CncAndOn.propTypes = {};

CncAndOn.defaultProps = {};

export default CncAndOn;
